import { Pipe, PipeTransform } from '@angular/core';

// Вспомогательные функции
function extractDeepPropertyByMapKey(obj: any, map: string): any {
  const keys = map.split('.');
  let result = obj;

  for (const key of keys) {
    if (result && typeof result === 'object' && key in result) {
      result = result[key];
    } else {
      return undefined;
    }
  }

  return result;
}

function extractDeepPropertyByParentMapKey(obj: any, map: string): { props: any, tail: string } {
  const keys = map.split('.');
  const tail = keys.pop()!;
  const props = extractDeepPropertyByMapKey(obj, keys.join('.'));

  return { props, tail };
}

function isNumberFinite(value: any): boolean {
  return typeof value === 'number' && isFinite(value);
}

function isBoolean(value: any): boolean {
  return typeof value === 'boolean';
}

function isString(value: any): boolean {
  return typeof value === 'string';
}

function isUndefined(value: any): boolean {
  return value === undefined;
}

@Pipe({
  name: 'filterBy',
  standalone: true
})
export class FilterByPipe implements PipeTransform {
  transform(input: any, props: any, search: any = '', strict: boolean = false): any {
    // Если input не массив - возвращаем как есть
    if (!Array.isArray(input)) {
      return input;
    }

    // Если props — функция, используем её как предикат фильтрации
    if (typeof props === 'function') {
      return input.filter(props);
    }

    // Если props не массив, преобразуем в массив
    let propsArray: string[] = [];
    if (Array.isArray(props)) {
      propsArray = props;
    } else if (typeof props === 'string') {
      propsArray = [props];
    } else if (typeof props === 'object' && props !== null) {
      // Если передан объект вида {'objrubric.id': value}, извлекаем ключи
      propsArray = Object.keys(props);
      // Если search не передан, берем значение из объекта
      if (search === '' && Object.keys(props).length > 0) {
        search = props[propsArray[0]];
      }
    } else {
      return input;
    }

    // Проверка на валидность search
    if (!isString(search) && !isNumberFinite(search) && !isBoolean(search) && !Array.isArray(search)) {
      return input;
    }

    const terms = String(search)
      .toLowerCase()
      .split(',');

    return input.filter(obj => {
      return propsArray.some(prop => {
        return terms.some(term => {
          const value = extractDeepPropertyByMapKey(obj, prop);
          const { props: parentProps, tail } = extractDeepPropertyByParentMapKey(obj, prop);

          if (isUndefined(value) && !isUndefined(parentProps) && Array.isArray(parentProps)) {
            return parentProps.some((parent: any) => {
              const str = String(parent[tail]).toLowerCase();
              return strict ? str === term : str.includes(term);
            });
          }

          if (isUndefined(value)) {
            return false;
          }

          const strValue: string = String(value).toLowerCase();

          return strict ? term === strValue : strValue.includes(term);
        });
      });
    });
  }
}
